export default [
    {
        path: "/Helper/UploadData/:title",
        name: "HelperUploadData",
        component: () => import("@/components/Helper/UploadData.vue"),
        meta: {
            name: "Helper",
            menuTitle : "Upload",            
            requiresAuth: true
        },
        props: true
    }
];